import {
  FULLPAGE_ILLUSTRATION_ICON_SIZE,
  ILLUSTRATION_ICON_SIZE,
  ILLUSTRATION_SMALL_SIZE,
} from './constants'

export const illustrationSizes = {
  fullPage: FULLPAGE_ILLUSTRATION_ICON_SIZE,
  medium: ILLUSTRATION_ICON_SIZE,
  small: ILLUSTRATION_SMALL_SIZE,
} as const
